import { atom } from 'jotai';
import { atomWithStorage } from "jotai/utils";


const tenantKey = 'tri.tenant';
const authenticationKey = 'tri.authentication';
const themeKey = 'tri.theme';
const jwtTokensKey = 'tri.jwt.tokens';

export const settingsAtom = atom(null);
export const conversationAtom = atom(null);
export const mapQueryAtom = atom(null);
export const mapDataAtom = atom(null);
export const mapOptionsAtom = atom({});
export const selectedEntityAtom = atom(null);
export const requestsAtom = atom([]);
export const requestIndexAtom = atom(0);
export const poisAtom = atom<any[]>([]);

function safeParseLocalStorage(key: string) {
    const raw = localStorage.getItem(key);
    if (raw && raw !== 'undefined' && raw !== '') {
        try {
            return JSON.parse(raw);
        } catch {
            return {};
        }
    }
    return {};
}

export const authenticationAtom = atomWithStorage(authenticationKey,
    safeParseLocalStorage(authenticationKey), {
    getItem: (_key: string, _initialValue: any) => {
        return safeParseLocalStorage(authenticationKey);
    },
    setItem: (key: string, value: any) => {
        try {
            localStorage.setItem(authenticationKey, JSON.stringify(value));
        } catch (error) {
            console.log(error);
        }
    },
    removeItem: (_key: string) => {
        localStorage.removeItem(authenticationKey);
    }
});

// JWT Tokens management
export const jwtTokensAtom = atomWithStorage('jwtTokens',
    safeParseLocalStorage(jwtTokensKey), {
    getItem: (_key: string, _initialValue: any) => {
        return safeParseLocalStorage(jwtTokensKey);
    },
    setItem: (key: string, value: any) => {
        try {
            localStorage.setItem(jwtTokensKey, JSON.stringify(value));
        } catch (error) {
            console.log(error);
        }
    },
    removeItem: (_key: string) => {
        localStorage.removeItem(jwtTokensKey);
    }
});

export const tenantAtom = atomWithStorage('tenant',
    safeParseLocalStorage(tenantKey), {
    getItem: (_key: string, _initialValue: any) => {
        return safeParseLocalStorage(tenantKey);
    },
    setItem: (key: string, value: any) => {
        try {
            localStorage.setItem(tenantKey, JSON.stringify(value));
        } catch (error) {
            console.log(error);
        }
    },
    removeItem: (_key: string) => {
        localStorage.removeItem(tenantKey);
    }
});

export const themeAtom = atomWithStorage('theme',
    safeParseLocalStorage(themeKey), {
    getItem: (_key: string, _initialValue: any) => {
        return safeParseLocalStorage(themeKey);
    },
    setItem: (key: string, value: any) => {
        try {
            localStorage.setItem(themeKey, JSON.stringify(value));
        } catch (error) {
            console.log(error);
        }
    },
    removeItem: (_key: string) => {
        localStorage.removeItem(themeKey);
    }
});

export const themeLoadingAtom = atom(true);

